import React from 'react'
import { createRoot } from 'react-dom/client'
import { UserSearch } from './components/UserSearch'

// Mount point: <div id="…" data-url="…" data-current-user="…" data-autofocus="true|false">
// (read from data attributes so nothing is interpolated into JS)
export const startSupportUserSearch = elementId => {
  const element = document.getElementById(elementId)
  createRoot(element).render(
    <UserSearch
      searchUrl={element.dataset.url}
      currentUserId={element.dataset.currentUser || ''}
      autoFocus={element.dataset.autofocus === 'true'}
    />
  )
}
